import styled from "styled-components";
import {useAppDispatch, useAppSelector} from "../../hooks";
import React, {useEffect, useState} from "react";
import {API_BACK_URL} from "../../components/CONSTANTS";
import {handleFetchResponseStatus} from "../../components/util";
import {setGenericStateFeature} from "../../features/genericDataSlice";
import hljs from "highlight.js/lib/core";
import {schemas} from "../../config";
import {toast} from "react-toastify";

const feature = 'act342winners'
export default function Act342WinnerEmail() {

    const list = useAppSelector(state => state.genericData[feature].list as any[])
    const dispatch = useAppDispatch()

    const [sending, setSending] = useState(false);

    const schema = schemas['act342']

    useEffect(() => {
        if (list === undefined) {
            fetch(
                `${schema.backend}/achillea/runSqlQuery.php?project=act342&query_key=winners`,
                {credentials: 'include'})
                .then(handleFetchResponseStatus)
                .then(r => r.json())
                .then(r => dispatch(setGenericStateFeature({
                    feature: feature,
                    value: {list: r.data}
                })))

        }

    }, [dispatch, list]);

    if ( list === undefined)
        return <div>Loading log...</div>


    function sendEmail() {
        setSending(true)
        toast.info("Відправляємо емейли. Може зайняти певний час...")
        fetch(
            `${schema.backend}/342/sendWinnersEmail.php`,
            {credentials: 'include', method: "POST"})
            .then(handleFetchResponseStatus)
            .then(r => r.json())
            .then(r => {
                if (r.have_error)
                    toast.error("Деякі емейли не були відправлені")
                if (r.error === true) {
                    toast.error(r.errorBody || "Сталась помилка при розсилці")
                } else {
                    toast.info("Емейли були відправлені переможцям. Оновіть таблицю")
                }
                setSending(false)
            })
    }

    return <Outer>
        <Container>
            <ul className="list">
                <li>
                    Список переможців:
                </li>
                {list.map((r, i) => <li key={i}>
                    {r.msisdn} - {r.prize} - {r.email}
                </li>)}
            </ul>
        </Container>
        <div className="send">
            <button onClick={sendEmail} disabled={sending} className={'btn-cmn'}>
                Відправити email переможцям
            </button>
        </div>
        <div className="text">
            <div>Текст емейлу:</div>
            Вітаємо з виграшем!<br/>
            Ви стали переможцем акції «Купуй від двох одиниць продукції TM «Clear Men» (КліарМен), ТМ «Rexona Men»
            (Рексона Мен), ТМ «Dove Men+Care» (Дав мен+кеа), TM «Axe» (Акс) зі знижкою до 25% одним чеком в будь-якій
            комбінації та отримай можливість виграти цінні подарунки: 1 (один) із 20 (двадцяти) електросамокатів, або 1
            (один) із 10 (десяти) ноутбуків, або 1 (одну) із 20 (двадцяти) Play Station 5» та виграли подарунок –
            {" {"}PRIZE{"}"}.<br/>
            Очікуйте дзвінка нашого представника.<br/>
            Дякуємо за участь!
        </div>
    </Outer>

}

const Outer = styled.div`
  margin-top: .5rem;

  .send {
    display: flex;
    margin-top: .5rem;
    width: 100%;
    justify-content: center;

    & button {
      flex-basis: 100%;
      max-width: 500px;
      width: 100%;
    }
  }

  .text {
    background: var(--table-row-odd-bg-color);
    color: var(--table-row-text-color);
    padding: .5rem;
    margin-top: .5rem;
  }
`

const Container = styled.div`
  display: flex;
  //width: 100%;

  & .list {
    flex-shrink: 0;
    padding: .5rem;
    background: var(--table-row-odd-bg-color);
    color: var(--table-row-text-color);
    min-width: 240px;
    max-height: 500px;
    overflow-y: auto;
    width: 100%;

    & li {

      font-size: 1rem;
      font-weight: bold;
      font-family: monospace;
    }
  }

  & .log {
    flex-grow: 1;
    flex-shrink: 0;
    //width: 100%;
    overflow-x: auto;
  }


  @media (max-width: 1000px) {
    flex-wrap: wrap;
  }
`
